/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_AuthInputs */

const en_landing_chips_auth = /** @type {(inputs: Landing_Chips_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication`)
};

const zh_landing_chips_auth = /** @type {(inputs: Landing_Chips_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份认证`)
};

/**
* | output |
* | --- |
* | "Authentication" |
*
* @param {Landing_Chips_AuthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_auth = /** @type {((inputs?: Landing_Chips_AuthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_AuthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_auth(inputs)
	return zh_landing_chips_auth(inputs)
});
export { landing_chips_auth as "landing.chips.auth" }